{ Storage } = require '@trello/storage'
log = require 'app/scripts/debug/log'

module.exports = new class
  delta: Storage.get('serverTimeDelta')
  updateServerTime: (time) ->
    @delta = (new Date(time) - new Date())
    Storage.set('serverTimeDelta', @delta)
    log('time', 'delta', @delta)

  serverToClient: (time) ->
    new Date((new Date(time)) - @delta)
